import { api } from '../api/client';

/**
 * Whether the course assistant is switched on for this deployment.
 *
 * Asked once per page load and shared: the welcome greeting and the
 * signed-out invitation both introduce the assistant, and neither should do
 * so on a deployment where it is off. Any failure counts as "off" — staying
 * quiet is the safe way to be wrong here.
 */
let pending: Promise<boolean> | null = null;

export function aiAvailable(): Promise<boolean> {
  pending ??= api<{ enabled: boolean }>('/ai/availability')
    .then((result) => Boolean(result.enabled))
    .catch(() => false);
  return pending;
}
